import { MenuPanel } from '@v2/brands/discountmags/Layouts/Full/Navigation';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

export default function AboutUsPanel() {
  const { buildUrl } = useUrlGenerator();
  return (
    <MenuPanel flush>
      <MenuPanel.Title padded title="About Us" />
      <MenuPanel.Item href={buildUrl('/about-us')} title="About Us" />
      <MenuPanel.Item href={buildUrl('/guarantee')} title="Our Guarantee" />
      <MenuPanel.Item href={buildUrl('/refund-policy')} title="Refund Policy" />
      <MenuPanel.Item href={buildUrl('/reviews')} title="Testimonials" />
      <MenuPanel.Item href={buildUrl('/affiliate-program')} title="Affiliate Program" />
      <MenuPanel.Item href={buildUrl('/privacy')} title="Privacy Policy" />
      <MenuPanel.Item href={buildUrl('/terms')} title="Terms of Service" />
    </MenuPanel>
  );
}
